<div class="bg-white rounded-2xl p-5 border border-blue-gray-100 shadow-card">
  <div class="flex items-start justify-between mb-4">
    <div>
      <p class="font-bold text-sm text-navy-900">Incidents assigned to you</p>
      <p class="text-xs mt-0.5 text-accent-100">Incident reports waiting for your review.</p>
    </div>
    <button
      type="button"
      class="text-xs font-semibold text-accent-500 whitespace-nowrap cursor-pointer bg-transparent border-none p-0 ml-4 mt-0.5 hover:underline"
      (click)="viewAll.emit()"
    >
      View all Incidents
    </button>
  </div>

  <ul class="divide-y divide-slate-100">
    @for (incident of incidents(); track incident.id) {
      <li
        class="group flex justify-between items-center gap-3 py-3 px-2 -mx-2 rounded-xl cursor-pointer transition-colors duration-150 hover:bg-slate-50"
        (click)="navigateToDetail(incident.id)"
      >
        <div class="flex flex-row gap-3 min-w-0 flex-1 sm:flex-none sm:w-52">
          <div class="shrink-0 w-9 h-9 rounded-xl flex items-center justify-center bg-red-500/8">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ef4444"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>

          <div class="flex-1 min-w-0">
            <p class="font-bold truncate text-navy-600 text-xs">
              {{ incident.incidentNumber ?? incident.id }}
            </p>
            <p class="truncate mt-0.5 text-muted text-xs">
              {{ incident.personsInvolved.join(', ') }}
            </p>
          </div>
        </div>

        <div class="shrink-0 sm:w-24">
          @if (incident.currentStage) {
            <span
              class="px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap"
              [style.background]="stageStyle(incident.currentStage).background"
              [style.color]="stageStyle(incident.currentStage).color"
            >
              {{ incident.currentStage.toLowerCase() !== 'completed' ? 'Stage ' : '' }}
              {{ incident.currentStage }}
            </span>
          }
        </div>

        @if (incident.categories.length > 0) {
          <div class="hidden sm:flex flex-1 flex-wrap gap-1.5 justify-center">
            @for (cat of incident.categories; track cat) {
              <span
                class="rounded-full px-2.5 py-0.5 border border-surface-300 whitespace-nowrap text-subtle text-2xs"
              >
                {{ cat }}
              </span>
            }
          </div>
        }

        <div
          class="sm:hidden bg-accent-500 shrink-0 w-8 h-8 rounded-full flex items-center justify-center ml-1"
        >
          <img
            src="/icons/arrow-right-white-icon.svg"
            alt=""
            width="14"
            height="14"
            aria-hidden="true"
          />
        </div>

        <div
          class="hidden sm:flex bg-accent-500 shrink-0 w-8 h-8 rounded-full items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-150 ml-1"
        >
          <img
            src="/icons/arrow-right-white-icon.svg"
            alt=""
            width="14"
            height="14"
            aria-hidden="true"
          />
        </div>
      </li>
    }

    @if (loading()) {
      <li class="py-8 text-center text-xs text-accent-100">Loading incidents…</li>
    } @else if (incidents().length === 0) {
      <li class="py-8 text-center text-xs text-accent-100">
        No incidents waiting for your review.
      </li>
    }
  </ul>
</div>
